export default "__VITE_ASSET__Cj9JkOe9__"